import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { IndicatorBoxModel } from '../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../models/qfilter.model';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';

@Component({
    selector: 'app-overview-promo',
    templateUrl: './overview-promo.component.html',
    styleUrls: ['./overview-promo.component.css']
})
//Pagina 5
export class OverviewPromoComponent implements OnInit {

    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
    public indicators: IndicatorBoxModel[] = [];
    public translations: any;
    public storeError = false;
    public selectOneError: string;
    public data: QFilterModel;
    public waterfallChart: LoyaltyChart;
    public investmentChart: LoyaltyChart;

    constructor(
        private indicatorService: IndicatorsService,
        private chartsService: IndicatorsChartService,
        private svcAnalytics: AnalyticsService,
        private srvCustomerCampaign: CustomerCampaignService,
        private translate: TranslateService,
        private searchModelFactory: SearchToolbarModelFactoryService,
    ) {

    }

    ngOnInit() {
        const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
        searchParams.svcAnalytics = this.svcAnalytics;
        searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
        searchParams.finestra = SearchToolbarFilterWindow.Five;
        searchParams.raggruppamento = SearchToolbarFilterGrouping.None;
        searchParams.disabledSections = [SearchToolbarSection.CardModes, SearchToolbarSection.Clusterlist, SearchToolbarSection.GroupTypes, SearchToolbarSection.Areas ];
        this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
            this.searchModel = model;
        });

        this.translate.get([
            'promo.promoDistributionValue',
            'promo.investment'
        ]).subscribe((t) => {
            this.translations = {
                promoDistributionValue: t['promo.promoDistributionValue'],
                investment: t['promo.investment']
            };
        });

        this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });
        this.initChart();

    }

    initChart() {
        this.waterfallChart = new LoyaltyChart('waterfall');
        this.waterfallChart.options.xAxis = {type: 'category'};
        this.waterfallChart.options.legend = {verticalAlign: "bottom"};
        this.waterfallChart.options.legend.enabled = false;

        this.investmentChart = new LoyaltyChart('area');
        this.investmentChart.options.plotOptions = { area: { stacking: 'normal' } };
        this.investmentChart.options.chart.zoomType = 'xy';
        this.investmentChart.options.legend = {layout: "horizontal", align: "center", verticalAlign: "bottom"};
        this.investmentChart.options.legend.enabled = true;

    }

    setChartInstance(chart: LoyaltyChart, chartInstance) {
        chart.instance = chartInstance;
    }


    searchValueTrend(data: QFilterModel) {

        this.data = data;


        this.translate.get([
            'indicator.investimento',
            'indicator.sconto_medio',
            'indicator.sconto_medio_volantino',
            'indicator.sconto_medio_loyalty'
        ]).subscribe(t => {
            this.indicators = [];

            Observable.zip(
                this.indicatorService.indicatorCalculation('Q120', this.data)
            ).subscribe(
                ([Q120]) => {

                    /*Q120*/
                    this.indicators.push(new IndicatorBoxModel([Q120.find(r => r.name === 'investimento')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
                    /*Q121*/
                    this.indicators.push(new IndicatorBoxModel([Q120.find(r => r.name === 'sconto_medio')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, t));
                    /*Q122*/
                    this.indicators.push(new IndicatorBoxModel([Q120.find(r => r.name === 'sconto_medio_volantino')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, t));
                    /*Q123*/
                    this.indicators.push(new IndicatorBoxModel([Q120.find(r => r.name === 'sconto_medio_loyalty')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, t));

                });

            this.waterfallChartInit (data);
            this.investmentChartInit (data);

        });

    }

    public toogleErrorStoreDialog() {
        this.storeError = !this.storeError;
    }

    waterfallChartInit (data) {

        Observable.zip (
            this.indicatorService.getChart('Q124', data, false)
        ).subscribe( ([res]) => {


            let serie0 = res.series[0].serie;
            let serie1 = res.series[1].serie;
            let series: Array<any> = [];

            if (serie1[serie1.length - 1] > 0) {
              serie1[serie1.length - 1] = -serie1[serie1.length - 1];
            }

            for (let i = 0; i < serie0.length; i++) {
                series.push ( {name: serie0[i], y: serie1[i]} );

            }

            if (this.waterfallChart.instance) {
                while (this.waterfallChart.instance.series.length > 0) {
                    this.waterfallChart.instance.series[0].remove(true);
                }
            }

            this.waterfallChart.options.series = [{ colorByPoint: true, data: series }];


            this.waterfallChart.options.tooltip = {
              formatter: function() {
                if (this.point.name === 'FATTURATO' && serie1[serie1.length - 1] < 0) {
                  return `<span style="color:${this.point.color}">● </span> ${this.point.name}: <b>${-this.point.y}</b><br/>`
                } else {
                  return `<span style="color:${this.point.color}">● </span> ${this.point.name}: <b>${this.point.y}</b><br/>`
                }
              }
            }


            this.waterfallChart.instance.addSeries(series);

            this.waterfallChart.instance.update(this.waterfallChart.options);

            this.waterfallChart.instance.redraw();

        });
    }

    public investmentChartInit (data: QFilterModel) {

        this.chartsService.loadChart(this.investmentChart, 'Q125', data, this.indicatorService, null, true);

    }

}



// WEBPACK FOOTER //
// ./src/app/views/overview/overview-promo/overview-promo.component.ts